import React from 'react';
import StarUserFormData from './StarUserFormData';
import ShareUserFormData from '../PublicUserFormData/ShareUserFormData';

const UserFormDataActionContainer = (props) => {
    return (
        <div
            className="d-flex flex-row align-items-center"
            style={{
                height: 'fit-content',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s ease',
                borderRadius: '14px',
                padding: '4px 8px',
                marginLeft: '8px',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
                gap: '4px',
            }}
        >
            <StarUserFormData {...props} />
            <ShareUserFormData {...props} compact />
        </div>
    );
};

export default UserFormDataActionContainer;
